import React from 'react';

import Icon from '../Icon/Icon';

const LightBubbleBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path d='M31.342 18a7 7 0 0 0-7-7' stroke='#00D1D2' strokeWidth='2' strokeLinecap='round' />
                <path stroke='#34303D' strokeWidth='2' strokeLinecap='round' d='M21 40h6' />
                <path
                    d='m30 28.221-.546-.838-.454.296v.542h1zm-12 0h1v-.542l-.454-.296-.546.838zM34 19a9.99 9.99 0 0 1-4.546 8.383l1.092 1.676A11.99 11.99 0 0 0 36 19h-2zM24 9c5.523 0 10 4.477 10 10h2c0-6.627-5.373-12-12-12v2zM14 19c0-5.523 4.477-10 10-10V7c-6.627 0-12 5.373-12 12h2zm4.546 8.383A9.99 9.99 0 0 1 14 19h-2a11.99 11.99 0 0 0 5.454 10.059l1.092-1.676zM19 30v-1.779h-2V30h2zm4 4a4 4 0 0 1-4-4h-2a6 6 0 0 0 6 6v-2zm2 0h-2v2h2v-2zm4-4a4 4 0 0 1-4 4v2a6 6 0 0 0 6-6h-2zm0-1.779V30h2v-1.779h-2z'
                    fill='#34303D'
                    fillRule='nonzero'
                />
            </g>
        </Icon>
    );
};

export default LightBubbleBlueIcon;
